/**
 * Primary destinations, shared by both shells (top bar and side rail) and the
 * phone tab bar. Icons are 24×24 stroke paths.
 */
export interface NavItem {
  id: 'schedule' | 'patients' | 'inbox' | 'labs' | 'imaging' | 'claims';
  label: string;
  path: string;
  icon: string;
  /** Show the inbox count on this item. */
  inboxBadge?: boolean;
}

export const NAV_ITEMS: readonly NavItem[] = [
  { id: 'schedule', label: 'Schedule', path: '/', icon: 'M4 6h16v14H4zM4 10h16M9 3v4M15 3v4' },
  { id: 'patients', label: 'Patients', path: '/patients', icon: 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM2 21c0-4 3-6 7-6s7 2 7 6M17 4a4 4 0 0 1 0 8M22 21c0-3-1.5-5-4-5.7' },
  { id: 'inbox', label: 'Inbox', path: '/inbox', icon: 'M4 5h16v11H8l-4 4V5z', inboxBadge: true },
  { id: 'labs', label: 'Labs', path: '/labs', icon: 'M9 3h6M10 3v6l-5 9a2 2 0 0 0 2 3h10a2 2 0 0 0 2-3l-5-9V3' },
  { id: 'imaging', label: 'Imaging', path: '/pacs', icon: 'M3 5h18v14H3zM8 15l3-4 3 3 2-2 3 3' },
  { id: 'claims', label: 'Claims', path: '/claims', icon: 'M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6' },
];

/** Which item owns a pathname. Charts (/patients/:id) belong to Patients. */
export function activeNavId(pathname: string): NavItem['id'] | null {
  if (pathname === '/' || pathname.startsWith('/appointments')) return 'schedule';
  if (pathname.startsWith('/patients')) return 'patients';
  if (pathname.startsWith('/inbox')) return 'inbox';
  if (pathname.startsWith('/labs')) return 'labs';
  if (pathname.startsWith('/pacs')) return 'imaging';
  if (pathname.startsWith('/claims')) return 'claims';
  return null;
}
